function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import ChartTooltip from "./ChartTooltip";
import { FormatMetric } from "../";

class ChartPieTooltip extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getColorByIndex", index => {
      const colors = this.props.colors;

      if (!colors[index]) {
        index = index - colors.length;
      }

      const color = colors && colors[index];
      return color;
    });

    _defineProperty(this, "renderLegend", (data, index) => {
      const colors = this.props.colors;
      let label = data.label,
          value = data.value,
          metricType = data.metricType;

      if (metricType) {
        value = React.createElement(FormatMetric, {
          type: metricType,
          value: value
        });
      }

      const color = this.getColorByIndex(index);
      const style = {
        backgroundColor: color
      };
      return React.createElement("li", {
        key: index
      }, React.createElement("div", {
        className: "admin-legend__chip",
        style: style
      }), React.createElement("b", {
        className: "admin-legend__label"
      }, label), React.createElement("i", {
        className: "admin-legend__value"
      }, value));
    });
  }

  render() {
    const data = this.props.data;
    return React.createElement("ul", null, data.map(this.renderLegend));
  }

}

_defineProperty(ChartPieTooltip, "defaultProps", {
  data: [],
  colors: []
});

export default ChartPieTooltip;